var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCircleCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#323755"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(13 -210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-ringing",
    transform: "translate(-6 217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M8.744,12.166a3.39,3.39,0,0,1-1.163-.208,12.4,12.4,0,0,1-4.5-2.87,12.4,12.4,0,0,1-2.87-4.5A3.365,3.365,0,0,1,.036,2.931,3.451,3.451,0,0,1,1.81.405,3.388,3.388,0,0,1,3.432,0,.38.38,0,0,1,3.8.3l.6,2.785a.38.38,0,0,1-.1.349l-1.02,1.02A10.007,10.007,0,0,0,7.713,8.889l1.02-1.02a.38.38,0,0,1,.349-.1l2.785.6a.38.38,0,0,1,.3.372,3.388,3.388,0,0,1-.405,1.622A3.451,3.451,0,0,1,9.235,12.13a3.382,3.382,0,0,1-.491.036ZM3.128.777A2.664,2.664,0,0,0,.923,4.326a11.531,11.531,0,0,0,6.918,6.918A2.664,2.664,0,0,0,11.39,9.038L9.124,8.553,8.059,9.618a.38.38,0,0,1-.43.075A10.765,10.765,0,0,1,2.474,4.538a.38.38,0,0,1,.075-.43L3.614,3.042Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M246.1,6.463a.38.38,0,0,1-.38-.38A5.328,5.328,0,0,0,240.4.76a.38.38,0,0,1,0-.76,6.083,6.083,0,0,1,6.083,6.083A.38.38,0,0,1,246.1,6.463Z",
    transform: "translate(-234.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M244.582,68.942a.38.38,0,0,1-.38-.38,3.806,3.806,0,0,0-3.8-3.8.38.38,0,0,1,0-.76,4.567,4.567,0,0,1,4.562,4.562A.38.38,0,0,1,244.582,68.942Z",
    transform: "translate(-234.317 -62.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M243.061,131.422a.38.38,0,0,1-.38-.38,2.284,2.284,0,0,0-2.281-2.281.38.38,0,1,1,0-.76,3.045,3.045,0,0,1,3.041,3.041A.38.38,0,0,1,243.061,131.422Z",
    transform: "translate(-234.317 -124.959)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleCallIcon);
export default __webpack_public_path__ + "static/media/BlueCircleCallIcon.c60df782.svg";
export { ForwardRef as ReactComponent };